import { dataFetcher } from '../Utils/dataFetcher'
import config from '../../temp/config'
import { CacheService } from '../Utils/Caching/cacheService'

interface Settings {
  [path: string]: string
}
export type getSettingsType = (paths: string[]) => Promise<Settings>
export const getSettings = async (cache: CacheService, paths: string[]): Promise<Settings> => {
  let cachedSettings: Settings = {}
  let fetchedSettings: Settings = {}

  const urlPathsToFetch = paths
    .map((path) => {
      // find path in cache
      const valueInCache = cache.get(path) as string
      //   if path is not in cache - we will fetch it
      if (!valueInCache) {
        return `&paths=${path}`
      }
      //   due to possible cache expiration we need to save cache into temporary object
      cachedSettings = { ...cachedSettings, ...{ path: valueInCache } }
      return
    })
    .join('')

  try {
    const url = `${config.sitecoreApiHost}/api/discoverywebsite/foundation/settings?language=${config.defaultLanguage}${urlPathsToFetch}`

    const response = await dataFetcher(url)
    const data = response.data as Record<string, string>
    for (const [key, value] of Object.entries(data)) {
      cache.set(key, value)
      fetchedSettings = { ...fetchedSettings, ...data }
    }

    return { ...cachedSettings, ...fetchedSettings }
  } catch (error) {
    console.error(error)
    return await Promise.reject(error)
  }
}

//  DON'T DELETE - used by DW
